import React from 'react'
import PropTypes from 'prop-types'
import Menu from '@mui/icons-material/Menu'

const MenuIcon = ({ height, width, ...more }) => {
	
	return (
		<Menu
			height={height}
			width={width}
			{...more}
		/>
	)
}

MenuIcon.propTypes = {
	height: PropTypes.number.isRequired,
	width: PropTypes.number.isRequired
}

export default MenuIcon
